import { Option } from "@/generated/graphql_billing";
import { CheckBox, Font } from "@moneyforward/mfx_biz_react_components";
import { SelectRowContainer } from "@/components/atoms/SelectRowContainer";
import { SelectRowItemCell } from "@/components/atoms/SelectRowItemCell";

type Prop = JSX.IntrinsicElements["div"] & {
  option: Option;
  selectedValues: string[];
};

export const AddOptionRowItem = (props: Prop) => {
  const { option, selectedValues = [], onClick, ...divProps } = props;

  return (
    <SelectRowContainer
      minWidth={960}
      minHeight={80}
      gridTemplateColumns="2.45fr 1.4fr 6.15fr"
      {...divProps}
    >
      <SelectRowItemCell
        css={{ justifyContent: "flex-start", marginLeft: 16 }}
        rightBorderDisplay
        onClick={onClick}
      >
        <CheckBox
          id={`${option.id}-check`}
          name="check"
          value={option.id}
          onChange={() => {}}
          checked={selectedValues.includes(option.id)}
        />
        <Font
          css={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            marginLeft: 8,
            marginRight: 8,
          }}
          variant="lb"
        >
          {option.name}
        </Font>
      </SelectRowItemCell>
      <SelectRowItemCell onClick={onClick} rightBorderDisplay>
        <Font variant="xlb">
          {option.priceIncludingTax === 0
            ? "無料"
            : option.priceIncludingTax.toLocaleString()}
        </Font>
        {option.priceIncludingTax > 0 && <Font variant="sb">円/月</Font>}
      </SelectRowItemCell>
      <SelectRowItemCell
        css={{
          justifyContent: "flex-start",
          marginLeft: 16,
          marginRight: 16,
          whiteSpace: "pre-wrap",
        }}
        onClick={onClick}
      >
        <Font>{option.description}</Font>
      </SelectRowItemCell>
    </SelectRowContainer>
  );
};
